import React from 'react';
import { motion } from 'framer-motion';
import { Home, Sun, Hammer, ArrowRight } from 'lucide-react';
import { content } from '../data/content';
const iconMap: Record<string, React.ElementType> = {
  home: Home,
  sun: Sun,
  hammer: Hammer
};
export function Services() {
  return <section id="services" className="py-20 md:py-28 bg-white" data-id="element-212">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-213">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-214">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-display text-4xl md:text-5xl font-bold text-brand-brown mb-6" data-id="element-215">
            {content.services.heading}
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-brand-brown/80" data-id="element-216">
            {content.services.subhead}
          </motion.p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-217">
          {content.services.items.map((service, index) => {
          const Icon = iconMap[service.icon];
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="group relative bg-brand-cream rounded-xl overflow-hidden shadow-lg hover:-translate-y-2 transition-all duration-300 flex flex-col h-full" data-id="element-218">
                <div className="relative h-64 overflow-hidden" data-id="element-219">
                  <div className="absolute inset-0 bg-brand-brown/20 group-hover:bg-transparent transition-colors duration-500 z-10" data-id="element-220" />
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-221" />
                  <div className="absolute top-4 left-4 z-20 bg-brand-cream p-3 rounded-full shadow-md" data-id="element-222">
                    <Icon className="w-6 h-6 text-brand-orange" data-id="element-223" />
                  </div>
                </div>

                <div className="p-8 flex-grow flex flex-col relative" data-id="element-224">
                  <h3 className="font-display text-2xl font-bold text-brand-brown mb-3" data-id="element-225">
                    {service.title}
                  </h3>
                  <p className="text-brand-brown/80 mb-6 flex-grow" data-id="element-226">
                    {service.description}
                  </p>

                  {/* Hover Reveal Sub-services */}
                  <div className="absolute inset-x-0 bottom-0 bg-brand-cream p-8 translate-y-full opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300 border-t border-brand-tan/20 shadow-[0_-10px_20px_rgba(0,0,0,0.05)]" data-id="element-227">
                    <ul className="space-y-2 mb-6" data-id="element-228">
                      {service.subServices.slice(0, 5).map((sub, i) => <li key={i} className="flex items-center text-sm text-brand-brown/90 font-medium" data-id="element-229">
                          <div className="w-1.5 h-1.5 rounded-full bg-brand-orange mr-2" data-id="element-230" />
                          {sub}
                        </li>)}
                      {service.subServices.length > 5 && <li className="text-sm text-brand-tan italic pl-3.5" data-id="element-231">
                          And more...
                        </li>}
                    </ul>
                  </div>

                  <a href="#contact" className="inline-flex items-center font-bold text-brand-orange hover:text-brand-brown transition-colors mt-auto relative z-20" data-id="element-232">
                    Learn More <ArrowRight className="w-4 h-4 ml-2" data-id="element-233" />
                  </a>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}